import { LeagueTableUserEvents } from "../analytics/events/leagueTable";
import { track } from "../analytics/track";

// // // //

/**
 * trackChangeDistribution
 * Tracks the event when a user changes the distribution filter in a League Table
 */
export function trackChangeDistribution(props: { distributionType: string }) {
    track(LeagueTableUserEvents.ChangeDistribution, props);
}
